import { createContext, useContext, type ReactNode } from 'react';

// Host content on the login screen's carousel, e.g. VRN's environment and version line.
export const LandingFooterContext = createContext<ReactNode>(null);

export const useLandingFooter = (): ReactNode => useContext(LandingFooterContext);
